import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-triangle-down",
  "use": "icon-icon-triangle-down-usage",
  "viewBox": "0 0 6 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 5\" id=\"icon-icon-triangle-down\"><path d=\"M2.445 4.374L.385 1.902C.135 1.602.078 1.257.217.87.355.48.603.286.96.286h4.08c.357 0 .604.194.743.583.139.388.083.732-.168 1.033l-2.06 2.472a.837.837 0 0 1-.258.214A.64.64 0 0 1 3 4.66a.64.64 0 0 1-.297-.072.837.837 0 0 1-.258-.214z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol